import { Button } from '@mui/material';
import TemplateCard from '../template-card';
import GridSkeleton from '@Components/General/Skeletons/grid';

interface TemplateListProps {
    templates: any[];
    onSelect: (template: any) => void;
    actionText?: string;
    selectedTemplate: any;
    onTemplateClick: (
        template: any,
        e?: React.MouseEvent<HTMLDivElement>,
    ) => void;
    isLoading?: boolean;
}

const TemplateList = ({
    templates,
    onSelect,
    actionText,
    selectedTemplate,
    onTemplateClick,
    isLoading,
}: TemplateListProps) => {
    if (isLoading) {
        return <GridSkeleton />;
    }

    return (
        <>
            {templates.map(template => (
                <TemplateCard
                    key={template.id}
                    template={template}
                    onSelect={onSelect}
                    onClick={() => onTemplateClick(template)}
                    selected={selectedTemplate?.id === template.id}
                    cardActions={
                        actionText && (
                            <Button
                                variant="tonal"
                                size="medium"
                                color="secondary"
                                onClick={e => onSelect(template)}
                            >
                                {actionText}
                            </Button>
                        )
                    }
                    sxProps={{
                        '& .MuiCardHeader-action': {
                            alignSelf: 'flex-end',
                            display: 'none',
                        },
                        '&:hover .MuiCardHeader-action': {
                            display: 'block',
                        },
                    }}
                />
            ))}
        </>
    );
};

export default TemplateList;
